/**
 * isiZulu: Dashboard
 *
 * What this file covers: The dashboard and its first-run setup checklist.
 *
 * Tone: Encouraging and brief. Tell the business what is happening and what to do next, in a few words.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const dashboard: Catalog = {
  'dashboard.welcome': 'Wamukelekile',
  'dashboard.title': 'Wamukelekile, {{name}}',
  'dashboard.title.anonymous': 'Siyakwamukela futhi',
  'dashboard.verifyBanner.title': 'Qinisekisa i-imeyili yakho',
  'dashboard.verifyBanner.cta': 'Qinisekisa manje →',
  'dashboard.metrics.unread': '{{count}} okungafundiwe',
  'dashboard.trend.percent': '{{value}}% uma kuqhathaniswa nayizolo',
  'dashboard.trend.points': '{{value}} amaphuzu uma kuqhathaniswa nayizolo',
  'dashboard.trend.flat': 'Kuzinzile',
  'dashboard.trend.flat.tooltip': 'Shintsho elincane emahoreni angu-24 edlule.',
  'dashboard.trend.tooltip': '{{current}} emahoreni angu-24 edlule, kuqhathaniswa no-{{previous}} emahoreni angu-24 ngaphambili.',
  'dashboard.metrics.deliveryRate': 'Izinga lokulethwa',
  'dashboard.metrics.deliveryHint': 'Kwemilayezo ethunyelwe emahoreni angu-24 edlule',
  'dashboard.metrics.deliveryNone': 'Ayikho imilayezo ethunyelwe okwamanje',
  'dashboard.viewMessages': 'Buka imilayezo',
  'dashboard.recent.title': 'Izingxoxo zakamuva',
  'dashboard.recent.openInbox': 'Vula ibhokisi lokungenayo →',
  'dashboard.recent.empty': 'Azikho izingxoxo okwamanje.',
  'dashboard.recent.noMessages': 'Ayikho imilayezo',
  'dashboard.quickActions.title': 'Izenzo ezisheshayo',
  'dashboard.quickActions.addContacts': 'Engeza oxhumana nabo',
  'dashboard.quickActions.newTemplate': 'Isifanekiso esisha',
  'dashboard.quickActions.newBroadcast': 'Ukusakaza okusha',
  'dashboard.quickActions.buildFlow': 'Yakha ukugeleza',
  'dashboard.quickActions.attachNumber': 'Namathisela inombolo',
  'dashboard.quickActions.topUp': 'Gcwalisa isikhwama',
  'setup.dismissed': 'Uhlu lokusetha lufihliwe. Ungalubuyisa ku-Izilungiselelo → Ukubukeka.',
  'setup.progress.badge': '{{done}} kwangu-{{total}} okuqediwe',
  'setup.step.done': 'Kuqediwe',
  'setup.step.todo': 'Akukenziwa',
  'setup.restore': 'Bonisa uhlu lokusetha',
  'setup.restore.hint': 'Buyisa izinyathelo zokuqala kudeshibhodi.',
  'dashboard.sendBlock.title': 'Imiyalezo yakho ayilethwa',
  'dashboard.sendBlock.ACCOUNT_NOT_PAYABLE': 'I-WhatsApp yenqaba yonke imiyalezo ku-{{number}} ngenxa yenkinga yokukhokha ngakithi. Siyayilungisa, futhi awudingi ukwenza lutho ku-Meta.',
  'dashboard.sendBlock.NUMBER_NOT_REGISTERED': 'I-{{number}} ayibhalisiwe ku-WhatsApp ukuthumela, ngakho akukho okuthunyelwe ngayo okufikayo.',
  'dashboard.sendBlock.META_REFUSED': 'I-WhatsApp yenqaba wonke umyalezo ku-{{number}}.',
  'dashboard.sendBlock.alsoOthers': 'Nezinye izinombolo ezingu-{{count}} zithintekile.',
  'dashboard.sendBlock.notCharged': 'Awukhokhiswa ngomyalezo ongalethwanga.',
  'dashboard.sendBlock.action': 'Vula Izinombolo'
};

export default dashboard;
